var TopBarView = Backbone.Epoxy.View.extend({
  template: 'layouts.topBar',
  bindings: 'data-bind',

  events: {
    'click .new-appointment-container': 'newAppointment',
    'click .add-wait-list-container': 'addToWaitList',
    'click .reviews-page-container': 'reviews',
    'click .services-page-container': 'services',
    'click .providers-page-container': 'serviceProviders',
    'click .my-account-container': 'myAccount',
    'click .gift-card-container': 'gifCards',
  },

  bindingSources: {
    client: function() {
      return bookedby.app.getCurrentClient();
    }
  },

  initialize: function() {
    this.model = bookedby.app.navigationModel;

    this.hasRendered = false;

    /*$(window).on("scroll", function(e) {
      if (this.scrollY > 140) {
        $('.top-bar-menu-container').addClass("fixed");
        $('.top-bar-placeholder').show();
      } else {
        $('.top-bar-menu-container').removeClass("fixed");
        $('.top-bar-placeholder').hide();
      }
    });*/

  },

  serialize: function() {

    return {
      isCustomNav: bookedby.staticData.storeGroupSettings.storeGroupMainWebsite
                    && bookedby.staticData.storeGroupSettings.topBarNavigationContent
                    && bookedby.staticData.storeGroupSettings.topBarNavigationContent.items
                    && bookedby.staticData.storeGroupSettings.topBarNavigationContent.items.length > 0,
      items: bookedby.staticData.storeGroupSettings.topBarNavigationContent ? bookedby.staticData.storeGroupSettings.topBarNavigationContent.items : null
    }
  },

  newAppointment: function() {
    var params = this.getCurrentStoreParams();

    /**
     * Quick fix to force service binding
     */
    if (bookedby.app.viewCache['start-booking'] != null && bookedby.app.ignoreNextBooking) {
      bookedby.app.viewCache['start-booking'].hasRendered = false;
      delete bookedby.app.viewCache['start-booking'];

      bookedby.app.navigateWithReplace('start-booking', {});
      return;
    }

    // to prevent navigation loops on some browsers, lock view refresh on top bar
    if (bookedby.app.viewCache['start-booking'] != null) {
      bookedby.app.viewCache['start-booking'].ignoreNextNavigation = true;
    }

    bookedby.app.navigateTo('start-booking', params);
  },

  addToWaitList: function() {
    bookedby.app.navigateTo('start-wait-list');
  },

  myAccount: function() {
    if (!bookedby.app.currentClient.get("loggedIn") ) {
      bookedby.app.navigateTo('login');
    } else {
      bookedby.app.navigateTo('profile');
    }
  },

  getCurrentStoreParams: function() {
    if (bookedby.app.currentlySelectedStore != null) {
      return {store: bookedby.app.currentlySelectedStore};
    } else {
      return {}
    }
  },

  reviews: function() {
    var params = this.getCurrentStoreParams();
    bookedby.app.navigateTo('reviews-page', params);
  },

  services: function() {
    var params = this.getCurrentStoreParams();
    bookedby.app.navigateTo('store-services', params);
  },

  serviceProviders: function() {
    var params = this.getCurrentStoreParams();
    bookedby.app.navigateTo('store-service-providers', params);
  },

  gifCards: function() {
    if (this.model.get('inGiftCardTab') || !bookedby.staticData.storeGroupSettings.enableGiftCards) {
      return;
    }

    var params = this.getCurrentStoreParams();
    bookedby.app.navigateTo('gift-cards', params);
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();

  },

  cleanup: function() {
    this.removeBindings();
  }
});

module.exports = TopBarView;